import { ScopeHooks } from "sockapi/scope-specs";
import { ScopeType } from "sockapi/scope-types";

export type BigBoardTeamPuzzleState = {
  solveTime?: number;
  numHintsUsed?: number;
  numWrongGuesses?: number;
  numMembers?: number;
  approachability?: number;
};

export type BigBoardTeamState = {
  numGrantedHints: number;
  unlocks: {
    [puzName: string]: BigBoardTeamPuzzleState;
  };
};

export type BigBoardTeamUpdate = {
  numGrantedHints?: number;
  unlocks?: {
    [puzName: string]: {
      solveTime?: number;
      numHintsUsed?: number;
      numWrongGuesses?: number;
      numMembers?: number;
    } | null;
  };
};

export const mergeBigBoardTeamUpdate = (
  upd1: BigBoardTeamUpdate,
  upd2: BigBoardTeamUpdate
) => {
  if (upd2.numGrantedHints !== undefined)
    upd1.numGrantedHints = upd2.numGrantedHints;
  for (const [puzName, puzUpds] of Object.entries(upd2.unlocks ?? {})) {
    upd1.unlocks ??= {};
    if (puzUpds === null) {
      upd1.unlocks[puzName] = null;
      return;
    }
    upd1.unlocks[puzName] = Object.assign(upd1.unlocks[puzName] ?? {}, puzUpds);
  }
};

export const updateBigBoardTeamState = (
  state: BigBoardTeamState,
  upd: BigBoardTeamUpdate
) => {
  const { numGrantedHints, unlocks } = upd;
  if (numGrantedHints !== undefined) state.numGrantedHints = numGrantedHints;
  for (const [puzName, puzUpds] of Object.entries(unlocks ?? {})) {
    state.unlocks[puzName] = Object.assign(
      state.unlocks[puzName] ?? {},
      puzUpds
    );
  }
};

export type BigBoardScopeSpec = {
  state: {
    teams: { [teamId: string]: BigBoardTeamState };
  };
  update: {
    addTeams?: { [teamId: string]: BigBoardTeamState };
    updTeams?: { [teamId: string]: BigBoardTeamUpdate };
  };
};

export const bigBoardScopeHooks: ScopeHooks<ScopeType.BIG_BOARD> = {
  identityFunc: (scope) => scope,
  update: (scopeState, payload) => {
    const { addTeams, updTeams } = payload;
    Object.assign(scopeState.teams, addTeams ?? {});
    for (const [teamId, teamUpd] of Object.entries(updTeams ?? {})) {
      const teamState = scopeState.teams[teamId];
      if (teamState === undefined)
        throw new Error("received big board update for non-existent team");
      updateBigBoardTeamState(teamState, teamUpd);
    }
  },
  disableClientCache: true,
};
